const items = [
  { label: "FOCUS", emoji: "🧠" },
  { label: "CHILL", emoji: "🌴" },
  { label: "ENERGY", emoji: "⚡" },
  { label: "SLEEP", emoji: "💤" },
  { label: "FOCUS", emoji: "🧠" },
  { label: "CHILL", emoji: "🌴" },
  { label: "ENERGY", emoji: "⚡" },
  { label: "SLEEP", emoji: "💤" },
];

const MarqueeTicker = () => {
  return (
    <div className="relative overflow-hidden bg-foreground py-4 select-none">
      <div className="animate-marquee flex whitespace-nowrap items-center">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-4 text-[2rem] sm:text-[3.5rem] heading-bold text-background tracking-[0.02em]">
              {item.label}
            </span>
            <span className="mx-3 text-[1.5rem] sm:text-[2.5rem] shrink-0" style={{ filter: 'grayscale(1) brightness(1.5) sepia(1) hue-rotate(10deg) saturate(5)' }}>
              {item.emoji}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default MarqueeTicker;
